import { Currency } from './types';

const currentDate = new Date();

export const dateVars = {
  current: currentDate,
  max: new Date(currentDate.getFullYear() + 10, 0, 1),
  min: new Date(2000, 0, 1)
};

export const emptyCells = {
  budget: '<no budget>',
  category: '<no category>',
  description: '<no description>'
};

export const routes = {
  login: '/login',
  registration: '/registration',
  settings: '/settings',
  budgetMonth: '/budgetmonth',
  budgets: '/budgets',
  budget: '/budget/:budgetId',
  accumulation: '/accumulation/:accumulationId',
  category: '/category/:categoryId',
  incomes: '/incomes',
  confirmEmail: '/confirmEmail',
  confirmEmailCallback: '/confirmEmailCallback',
  home: '/'
};

export const settingPages = {
  profile: 'profile',
  categories: 'categories',
  preferences: 'preferences'
};

export const defaultCurrency: Currency = 'uah';

export const currencies: Record<
  Currency,
  {
    code: string;
    symbol: string;
    name: string;
    symbolPosition: 'before' | 'after';
  }
> = {
  usd: { code: 'usd', symbol: '$', name: 'USD', symbolPosition: 'before' },
  eur: { code: 'eur', symbol: '€', name: 'EUR', symbolPosition: 'after' },
  uah: { code: 'uah', symbol: '₴', name: 'UAH', symbolPosition: 'after' }
};
